function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 2C6.478 2 2 6.478 2 12s4.478 10 10 10 10-4.478 10-10S17.522 2 12 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.616 7.423c-.704-.617-1.632-.954-2.616-.954-.984 0-1.912.34-2.616.954-.73.64-1.134 1.5-1.134 2.42v.179c0 .103.084.187.188.187h1.124a.188.188 0 00.188-.187v-.178c0-1.034 1.01-1.875 2.25-1.875s2.25.841 2.25 1.875c0 .729-.516 1.397-1.315 1.704a2.62 2.62 0 00-1.22.958c-.308.446-.467.98-.467 1.521v.504c0 .103.084.188.187.188h1.125a.188.188 0 00.188-.188V14a1.132 1.132 0 01.724-1.05c1.383-.532 2.276-1.75 2.276-3.105.002-.921-.401-1.781-1.132-2.421zm-3.553 9.733a.938.938 0 101.875 0 .938.938 0 00-1.876 0z"
})));